import { isValidUrl } from '@studio/utils/validation';
import { Component } from '@angular/core';
import { ICreative } from '@domain/creativeset/creative';
import { addMissingProtocol } from '@studio/utils/url';
import { CommonModule } from '@angular/common';
import { UIModule } from '@bannerflow/ui';
import { VersionFromIdPipe } from '../../../shared/pipes/version-from-id.pipe';

@Component({
    imports: [CommonModule, UIModule, VersionFromIdPipe],
    selector: 'url-dialog',
    templateUrl: 'url-dialog.component.html',
    styleUrls: ['url-dialog.component.scss']
})
export class UrlDialogComponent {
    url: string | undefined;
    label: string;
    buttonLabel = 'Save target url';
    placeholder = `Leave blank to use the version's target URL`;
    creatives: ICreative[];
    tooltip: string;

    private closePromise: Promise<string | 'cancel' | undefined>;
    private resolveClosePromise: (value?: string | 'cancel' | undefined) => void;

    initiate(
        url: string | undefined,
        config?: IUrlDialogConfig
    ): Promise<string | 'cancel' | undefined> {
        if (config) {
            this.creatives = config.creatives;
        }

        if (url) {
            this.url = url;
        }

        if (!this.closePromise) {
            this.closePromise = new Promise(resolve => (this.resolveClosePromise = resolve));
        }
        return this.closePromise;
    }

    openUrl(): void {
        if (this.url) {
            window.open(addMissingProtocol(this.url), '_blank');
        }
    }

    cancel(): void {
        this.resolveClosePromise('cancel');
    }

    save(): void {
        const url = this.url?.trim();
        if (this.isValid()) {
            const value = !url || this.isBlank(url) ? undefined : addMissingProtocol(url);
            this.resolveClosePromise(value);
        }
    }

    isValid(): boolean {
        const url = this.url?.trim();
        if (url) {
            return isValidUrl(addMissingProtocol(url));
        }
        return true;
    }

    private isBlank = (str: string | undefined): boolean => !str || /^\s*$/.test(str);
}

export interface IUrlDialogConfig {
    creatives: ICreative[];
}
